const RESOURCE_NAME = '/analytics';

export default axios => ({
    getAnalytics(unitId, period, params) {
        return axios.get(`${RESOURCE_NAME}/${unitId}/${period}`, {params});
    },
});